import { BrandsState, initialBrandsListState } from 'mk2/apps/strollers/containers/BrandsList/BrandsList.reducers';
import { BrandEntity, StrollerBrandSchema } from 'mk2/apps/strollers/schemas';
import { AppState } from 'mk2/reducers';
import { getDenormalizedEntities } from 'mk2/selectors';

export const getStrollerBrandsListState = (state: AppState): BrandsState =>
    state.containers.strollers.brandsList || initialBrandsListState;
export const getStrollerBrandsListItems = (state: AppState): BrandEntity[] =>
    getDenormalizedEntities<BrandEntity>(state, StrollerBrandSchema, getStrollerBrandsListState(state).brandIds);
